module.exports = __webpack_public_path__ + "img/sour-talk.f97644c8.png";